import { SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { MOBILE_WIDTH, TABLET_WIDTH } from "hooks/useDeviceType";

export const Title = styled.h3(({ css }: { css?: SerializedStyles }) => {
  return {
    textAlign: "center",
    fontFamily: "Quincy CF",
    fontSize: 80,
    fontWeight: 900,
    lineHeight: "100%",

    [`@media (max-width: ${TABLET_WIDTH}px)`]: {
      fontSize: 60,
    },

    [`@media (max-width: ${MOBILE_WIDTH}px)`]: {
      fontSize: 30,
    },

    ...css,
  };
});
